import "./Layout.css";

import { Card, Container } from "react-bootstrap";
import { Link } from "react-router";

import BackButton from "../../components/BackButton";
import Header from "../Header/Header";

export function Title({ backButtonUrl, title, children }) {
    return (
        <Card.Body className="p-4">
            <div className="d-flex flex-wrap flex-md-nowrap align-items-start">
                <h3 className="d-flex align-items-start m-0 flex-grow-1 min-w-0 me-md-2 mb-1">
                    {backButtonUrl && (
                        <BackButton
                            as={Link}
                            to={backButtonUrl}
                            className="me-2"
                        />
                    )}
                    <span style={{ wordBreak: "break-word", minWidth: 0 }}>
                        {title}
                    </span>
                </h3>

                <div className="d-flex flex-wrap flex-md-nowrap justify-content-end ms-auto flex-shrink-0">
                    {children}
                </div>
            </div>
        </Card.Body>
    );
}

function LayoutBase(props) {
    const maxWidth = "850px";

    return (
        <>
            <Header style={{ maxWidth }} className="mb-4" />
            <Container style={{ maxWidth }} className="mb-5">
                {props.children}
            </Container>
        </>
    );
}

export default function Layout(props) {
    return <LayoutBase {...props} />;
}
